module.exports = "html, body {\n  background-color: whitesmoke;\n  margin: 0;\n  padding: 0; }\n"